const DEFAULT_DATA = {
  columns: 4,
  showTabs: false,
  pagination: "infinite",
  contentFilters: [
    "blog-created",
    "blog-updated",
    "page-created",
    "page-updated",
    "comment-posted",
  ],
  maxNumberOfItems: 4,
  borderRadius: 8,
};

export const RECENTLY_ACTIVE_TEMPLATES = [
  {
    id: crypto.randomUUID(),
    ...DEFAULT_DATA,
    view: "card",
  },
  {
    id: crypto.randomUUID(),
    ...DEFAULT_DATA,
    view: "list",
  },
];

export const buildTemplate = (view, borderRadius) => ({
  ...DEFAULT_DATA,
  view,
  borderRadius,
});
